/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2024-12-23 10:38:38 */

const Keys = {
  apply: 'apply',
  selectAll: 'selectAll',
  removeAll: 'removeAll',
  removeAllChoices: 'removeAllChoices',
  ALL: 'ALL',
  DE_ALL: 'DE_ALL',
  DE_NORTH: 'DE_NORTH',
  DE_SOUTH: 'DE_SOUTH',
  DE_EAST: 'DE_EAST',
  DE_WEST: 'DE_WEST',
  AUT: 'AUT',
  CZE: 'CZE',
  CHE: 'CHE'
}; export default Keys;